import React from 'react'

export const LabelImg = ({text}) => {
  return (
    <div className='label d-flex justify-content-center align-items-center position-relative'>
        
      <h1 className='text-display'>{text}</h1>

    </div>
  )
}
